import IconButton, { IconButtonProps } from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import RemoveIcon from '@material-ui/icons/Remove';
import React from 'react';

export const DecrementButton = React.memo(({ ...props }: IconButtonProps) => {
    return (
        <InputAdornment position="start">
            <IconButton size={'small'} {...props}>
                <RemoveIcon />
            </IconButton>
        </InputAdornment>
    );
});
